import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { CustomizedMachineModelInf } from './CustomizedMachineModelInf';
import { BaseBarcode } from '../../controls/BaseBarcode';
import { CustomerInfo } from './CustomerInfo';
import { HearingLossData } from './HearingLossData';
import { DealerInfo } from './DealerInfo';
import toLocalString from '../../infrastructure/DateTimeFunctions';

export class OtherCustomerMadeView extends Component {   
    constructor(props) {
        super(props);                
    }    

    renderRemark() {
        //let printMode = this.props.printMode;
        //console.log(this.props.printMode);
        //if (printMode === true) {
        //    return null;
        //}
        return (<label className="no-print text-xs ml-4 text-red-500">{this.props.remark}</label>);
    }
    render() {
        let data = this.props.model;        
        if (!data) {
            return null;
        }
        //console.log(data.dealerInfo.isOtherPlatform);
        return (            
            <div id="pDiv" className="bg-white overflow-hidden sm:rounded-sm text-xs pb-1">
                <div className="flex flex-col px-8" id="orderForm" style={{ pointerEvents:"none" }}>
                    <div className="w-full overflow-hidden  mt-4">
                        <div className="grid grid-cols-3">
                            <div className="text-sm flex items-center">
                                <BaseBarcode value={data.orderNum} />
                                {this.renderRemark()}
                            </div>
                            <div className="text-center"><h1 className="text-4xl font-bold"><FormattedMessage id="CustomerOrderTitle" />
                                {data.dealerInfo.isOtherPlatform && <span className="text-sm  text-red-500">（<FormattedMessage id="TingzhanOrder" />）</span>}
                            </h1></div>
                            <div className="flex justify-between">
                                <div className="flex items-center">
                                    <div className="w-44">
                                    <div className="bg-blue-800 text-white px-2 font-bold"><FormattedMessage id="InfoOrderNum" /></div>
                                        <div className="bg-gray-200 h-8 px-1 pt-1 text-sm">{data.infoId}</div>
                                    </div>
                                </div>
                                {data.brandLogoUrl && <img className="" style={{ maxWidth: 170, maxHeight:80 }} src={data.brandLogoUrl} />}
                            </div>
                        </div>

                    </div>

                    <div className="flex justify-between gap-1 w-full">
                        <DealerInfo model={data.dealerInfo} />
                        <CustomerInfo orderNum={data.orderNum} model={data.customerInfo} />
                        <HearingLossData data={data.hearingLossData}  />
                    </div>
                    <CustomizedMachineModelInf orderNum={data.orderNum} specialRequirements={data.specialRequirements} printMode={this.props.printMode} model={data.customizedMachineModelInf} deliverAccountCode={data.dealerInfo.deliverAccountCode} fillingPerson={data.fillingPerson} contactDetails={data.contactDetails} orderTime={data.orderTime ? toLocalString(data.orderTime, true) : ""} />
                </div>
                <div className="text-gray-500 text-xs italic mx-4 mt-1">
                    <FormattedMessage id="OrderFillingInstructionsClaim" />
                </div>
            </div>
        );

    }

}
